// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__acVn2","label":"styles_label__35Bg2"};